import clsx from "clsx";
import React, {FunctionComponent} from "react";
import {HTMLInputElementProps, PropsWithOverwrite} from "../../../utils/input";
import Loader from "../../widget/Loader";
import {ButtonSize, ButtonStyle} from "../button/Button";
import Icon from "../icon/Icon";
import {Action} from "../../../utils/Action";

type ButtonUploadProps = PropsWithOverwrite<HTMLInputElementProps, {
    label: string;
    onChange: (value?: File) => void;
    acceptType?: string;
    loading?: boolean;
    size?: ButtonSize;
    style?: ButtonStyle;
    cssClass?: string;
}>;

const ButtonUpload: FunctionComponent<ButtonUploadProps> = ({
    label,
    onChange,
    acceptType,
    loading,
    size = ButtonSize.MEDIUM,
    style = ButtonStyle.PRIMARY_GREEN,
    cssClass,
    ...inputAttr
}) => {
    return (
        <div className={clsx("btn-upload", size, style, {"btn-upload--disabled": inputAttr.disabled || loading}, cssClass)}>
            <input
                type="file"
                onChange={(e) => onChange(e.target.files ? e.target.files[0] : undefined)}
                accept={acceptType || ".csv,.xlsx,.xls"}
                disabled={inputAttr.disabled || loading}
                {...inputAttr}
            />
            <Icon {...Action.UPLOAD.icon}/>
            <span>{label}</span>
            {loading && <Loader cssClass="btn__loader" small/>}
        </div>
    );
};

export default ButtonUpload;
